module.exports = __webpack_public_path__ + "img/cabbage-clean-medium.5332c66a.png";